<div class="body-section welcome-products">
    <div class="body-section__wrapper d-block">
        <div class="d-flex flex-column justify-content-center align-items-center pt-4 pt-xl-5 w-100 text-center">
            <div class="col-12 text-center p-0">
                <img
                    class="w-100"
                    src="{{ assetsUrl }}{{ mfsPath }}/img/front/images/emptySearch.svg"
                    alt="IG-Connect"
                />
            </div>
            <div class="col-12 p-0 px-3 pt-xl-4 mb-5 mt-4 mb-xl-0">
                <div class="container-text d-flex flex-column align-items-center mx-auto">
                    <h4>
                        {{ 'app.global.modals.image_manager.upload_image_modal.pexels.empty.title' | translate }}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</div>
